import {
  MESSAGE_MP4 as BASE_MESSAGE_MP4,
  ACTION_ITEM as BASE_ACTION_ITEM,
  DECISION as BASE_DECISION,
} from "../livechatMp4/constant";

export * from "../livechatMp4/constant";

export const MESSAGE_MP4 = {
  ...BASE_MESSAGE_MP4,
  next: null,
};

export const ACTION_ITEM = {
  ...BASE_ACTION_ITEM,
  next: null,
};

export const DECISION = {
  ...BASE_DECISION,
  next: null,
};
